import { persistStore } from "redux-persist";
import store from "./configureStore";
export * from "./RootState";


const persistor = persistStore(store);

export { store, persistor};
